import React from 'react';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import { NonExchangeDay, NonExchangeDayFilters } from '../../../../app/models/NonExchangeDay';
import { momentParseDate } from '../../../../helpers';
import NonExchangeDayFilter from './NonExchangeDayFilter';
import NonExchangeDaySwitchChange from '../NonExchangeDaySwitchChange';

interface Props {
    nonExchangeDays: NonExchangeDay[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    show?: (id: number) => void;
    destroy?: (id: number) => void;
    filter: NonExchangeDayFilters;
    setFilter: (filter: NonExchangeDayFilters) => void;
    paginationRowsPerPageOptions?: any[];
    callbackSuccess: () => void;
}

const NonExchangeDayDataTable = ({
    nonExchangeDays,
    totalRows,
    loading = false,
    edit,
    destroy,
    show,
    filter,
    setFilter,
    callbackSuccess
}: Props) => {
    const columns = [
        {
            name: 'Id',
            selector: (row: any) => row.id,
            sortable: true,
            sortField: 'id', 
            cell: (row: NonExchangeDay) => <span className="">{row.id}</span>
        },
        {
            name: 'Nombre',
            selector: (row: any) => row.name,
            sortable: true,
            sortField: 'name',
            cell: (row: NonExchangeDay) => <span className="">{row.name}</span>
        },
        {
            name: 'Fecha Referencia',
            selector: (row: any) => row.date,
            sortable: true,
            sortField: 'date',
            cell: (row: NonExchangeDay) => <span className="">{momentParseDate(row.date)}</span>
        },
        {
            name: 'Período',
            selector: (row: any) => row.period,
            sortable: true,
            sortField: 'period',
            cell: (row: NonExchangeDay) => {
                const periodMap: { [key: string]: string } = {
                    'No repetir': 'No repetir',
                    'Semanal': 'Semanal',
                    'Mensual': 'Mensual',
                    'Anual': 'Anual'
                };
                return <span className="">{periodMap[row.period] || row.period}</span>;
            }
        },
        {
            name: 'Monedas',
            selector: (row: any) => row.currencies,
            sortable: false,
            cell: (row: NonExchangeDay) => (
                <span className="">
                    {row.currencies?.map(currency => currency.name).join(', ')}
                </span>
            )
        },
        {
            name: 'Activo',
            selector: (row: any) => row.is_active,
            sortable: true,
            sortField: 'is_active',
            cell: (row: NonExchangeDay) => (
                <NonExchangeDaySwitchChange
                    checkValue={row.is_active ?? true}
                    nonExchangeDayId={row.id!}
                    callbackSuccess={callbackSuccess}
                />
            )
        },
        {
            name: 'Acciones',
            selector: (row: any) => row.id,
            sortable: false,
            cell: (row: NonExchangeDay) => (
                <div className="">
                    {show && (
                        <ButtonTableAction
                            callbackFunction={() => show(row.id ?? -1)}
                            classIcon={'mdi mdi-eye'}
                            colorIcon={'text-info'}
                            errorMessage={'No se puede mostrar este registro.'}
                            title={'Ver'}
                        />
                    )}
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? -1)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            errorMessage={'No se puede editar este registro.'}
                            title={'Editar'}
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.id ?? -1)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este registro.'}
                            title={'Eliminar'}
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    <NonExchangeDayFilter filter={filter} setFilter={setFilter} />
                </div>
            </div>

            <DefaultDataTable
                columns={columns}
                data={nonExchangeDays}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default NonExchangeDayDataTable; 